import { Controller } from "@hotwired/stimulus"

// Toggle trade fields for marketplace items
// Values: openForTrade (boolean), inSearchOf
// Targets: tradeFields, checkbox
export default class extends Controller {
  static values = { openForTrade: Boolean }
  static targets = ["tradeFields"]

  connect() {
    this.render()
  }

  toggle(event) {
    this.openForTradeValue = event.target.checked
    this.render()
  }

  render() {
    if (this.openForTradeValue) {
      this.tradeFieldsTarget.innerHTML = `<div class="my-4">
        <textarea
          id="marketplace_item_in_search_of"
          placeholder="What are you looking to trade for?"
          type="text"
          name="marketplace_item[in_search_of]"
          class="input-text"
        >${this.tradeFieldsTarget.dataset.inSearchOf || ""}</textarea>
      </div>`
    } else {
      this.tradeFieldsTarget.innerHTML = `<input type="hidden" name="marketplace_item[open_for_trade]" id="marketplace_item_open_for_trade" value="false" />`
    }
  }
}
